// extracted by mini-css-extract-plugin
export var gif = "_ky-0";